import shindeHouse1 from "../../assets/shinde-house/shinde house c bed.png"; 
import shindeHouse2 from "../../assets/shinde-house/kitchen.png";
import shindeHouse3 from "../../assets/shinde-house/Luxurious Modern Entrance Foyer.png";
import shindeHouse4 from "../../assets/shinde-house/wardrobe-img.jpeg";
import shindeHouse5 from "../../assets/shinde-house/study-room-ai.png";
import shindeHouse6 from "../../assets/shinde-house/bedroom.png";
import shindeTransformationVideo from "../../assets/shinde-house/transformation.mp4";
import shindeHouse7 from "../../assets/shinde-house/ChatGPT Image Aug 19, 2026, 06_52_01 PM.png";

const ShindeHouse = {
    title: "Shinde House",
    category: "Residential / 3BHK Bunglow",
    facts: [
      { label: "Location", value: "Nigadi Pradhikaran, Pune" },
      { label: "Year", value: "2026" },
      { label: "Area", value: "2200 sq ft" },
      { label: "Category", value: "Residential" },
      { label: "Services", value: "Complete Renovation" },
    ],
    heroImage: shindeHouse1,
    heroAlt: "Shinde House interior in Nigadi Pradhikaran, Pune",
    overview:
      "Complete 3BHK bungalow renovation in Nigdi Pradhikaran, Pune, featuring modern bathroom renovation, electrical upgrades, contemporary flooring, and custom furniture design for a stylish and functional home.",
    fullbleedImage: shindeHouse2,
    fullbleedAlt: "Shinde House living space detail",
    fullbleedQuote: "Complete renovation creating a modern living environment with practical functionality.",

fullbleedImage2: shindeHouse7,
fullbleedAlt2: "Shinde House dining area",
fullbleedQuote2: "A dining space made for slow meals and warm conversations.",

    // chapters: [
    //   {
    //     eyebrow: "01 - Vision",
    //     title: "Bringing the Vision to Life",
    //     body: "A newly constructed home takes shape with a clear interior vision—balancing modern aesthetics, comfort and everyday functionality.",
    //     video: shindeTransformationVideo,
    //     alt: "Shinde House transformation video",
    //   },
    //   {
    //     eyebrow: "02 - Planning",
    //     title: "Designed Around You",
    //     body: "From spatial planning to electrical points, storage and materials, every detail is planned to create a home that feels seamless and personal.",
    //     image: shindeHouse3,
    //     alt: "Shinde House living area",
    //   },
    //   {
    //     eyebrow: "03 - Execution",
    //     title: "Where Ideas Take Shape",
    //     body: "Custom furniture, lighting, finishes and details come together on site, turning the design concept into beautiful, functional spaces.",
    //     image: shindeHouse5,
    //     alt: "Shinde House construction detail",
    //   },
    //   {
    //     eyebrow: "04 - Delivery",
    //     title: "Made to Feel Like Home",
    //     body: "The final touches bring everything together—creating a warm, contemporary home that is ready for everyday living.",
    //     image: shindeHouse4,
    //     alt: "Shinde House finished space",
    //   },
    // ],
    
    
    chapters: [
  {
    eyebrow: "01 - IN THE MAKING",
    title: "Building the Details",
    body: "Interior work comes to life on site, with every element carefully installed to shape the home's final look and functionality.",
    video: shindeTransformationVideo,
    alt: "Shinde House interior work in progress",
  },
  // {
  //   eyebrow: "02 - THE ENTRANCE",
  //   title: "A Strong First Impression",
  //   body: "A bold entrance combines clean geometry, metal detailing and contemporary character to set the tone for the home.",
  //   image: shindeHouse3,
  //   alt: "Shinde House contemporary entrance",
  // },

{
  eyebrow: "02 - THE ENTRANCE",
  title: "A Strong First Impression",
  body: "A bold entrance combines clean geometry, metal detailing and contemporary character to set the tone for the home.",
  image: shindeHouse3,
  alt: "Shinde House contemporary entrance",
  mobileFit: "contain",
},

  {
    eyebrow: "03 - THE WORKSPACE",
    title: "Designed to Work Beautifully",
    body: "A personalised study blends custom storage, a dedicated workspace and warm lighting to create a space that inspires focus.",
    image: shindeHouse5,
    alt: "Shinde House custom study and workspace",
  },

  // {
  //   eyebrow: "04 - THE WARDROBE",
  //   title: "Storage with Style",
  //   body: "Thoughtfully designed wardrobes bring together ample storage, elegant finishes and subtle lighting without compromising the room's visual appeal.",
  //   image: shindeHouse4,
  //   alt: "Shinde House custom wardrobe and storage",
  // },

  {
  eyebrow: "04 - THE WARDROBE",
  title: "Storage with Style",
  body: "Thoughtfully designed wardrobes bring together ample storage, elegant finishes and subtle lighting without compromising the room's visual appeal.",
  image: shindeHouse4,
  alt: "Shinde House custom wardrobe and storage",
  mobileFit: "contain",   
},

 {
    eyebrow: "05 - THE BEDROOM  ",
    title: "A Restful Retreat",
    body: "A serene bedroom designed for relaxation, featuring custom storage and soft lighting.",
    image: shindeHouse6,
    alt: "Shinde House custom bedroom",
    mobileFit: "contain",
  },

],
    
    gallery: [
      {
        image: shindeHouse1,
        alt: "Shinde House custom bedroom interior with warm finishes",
        caption: "Bedroom with custom storage and soft lighting",
      },
      {
        image: shindeHouse2,
        alt: "Shinde House kitchen with modern cabinetry",
        caption: "Modular kitchen with clean working surfaces",
      },
      {
        image: shindeHouse3,
        alt: "Shinde House entrance door and wall detail",
        caption: "Entrance detail with bold door treatment",
      },
      {
        image: shindeHouse4,
        alt: "Shinde House wardrobe and storage wall",
        caption: "Wardrobe storage finished with a clean modern look",
      },

 {
        image: shindeHouse6,
        alt: "Shinde House bedroom ",
        caption: "Bedroom and soft lighting",
      },

    ],
  };

export default ShindeHouse;
